import { useEffect } from "react";
import { batch, useSignal } from "@preact/signals-react";
import { postSubmit, isEmpty } from "@ui-seeker/utils";
import { useAppToast } from "@ui-seeker/app";

import { WEBBACK_V2_API } from "@constants";
import {isLoadingCommonFilters, commonFiltersValue, isSystemBusy} from "@signals";
import {
	resetMarketplacesLostBuyBoxSignal,
	marketplacesLBBIsEmpty,
	marketplacesLBBSubmittedFilters
} from "../../@signals";


export default function useMarketplacesLostBuyBoxTableData() {

	const { showToast } = useAppToast()

	const tableData = useSignal([])

	useEffect(() => {
		if (isLoadingCommonFilters.value) batch(() => {
			resetMarketplacesLostBuyBoxSignal()
			marketplacesLBBSubmittedFilters.value = commonFiltersValue.peek()
			postSubmit(`${WEBBACK_V2_API}/marketplaces/lose-buy-box-details/table`, commonFiltersValue.value).then((res) => {
				if (!res?.length)
					marketplacesLBBIsEmpty.value = true
				tableData.value = res
			}).catch(() => isSystemBusy.value = true
			).finally(() => {
				isLoadingCommonFilters.value = false
			})
		})
	}, [isLoadingCommonFilters.value])

	return {
		tableData: tableData.value,
	}
}